function NextArrowDatePickerIcon({ size = '24', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 23"
      fill="none"
    >
      <path
        d="M9 5.25L14.9293 11.1793C14.9683 11.2183 14.9683 11.2817 14.9293 11.3207L9 17.25"
        stroke="url(#paint0_linear)"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="18"
          y1="11.25"
          x2="8.4"
          y2="6.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default NextArrowDatePickerIcon;
